import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import ToggleOption from '../../../Form/ToggleOption';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../../Desktop/DesktopBookingWi... Remove this comment to see the full error message
import s from '../../Desktop/DesktopBookingWidgetForm.css';
import { IS_EXISTING_PATIENT_FIELD_NAME, isFieldRequired } from '../../util/validators';
import { getYesNoToggleOptions } from '../../util';
import { emptyFieldValidator } from '../../../../core/util/rcForm/validators';
import ExistingPatientCta from './ExistingPatientCta';
import { smallerThanOrEqualTo } from '../../../../core/util/styledComponents';

const Root = styled.div.withConfig({ componentId: 'sc-1wvidb8-0' })`
  margin-top: 10px;
  background-color: ${colors.white};
  ${smallerThanOrEqualTo.md`
    margin-bottom: 10px;
  `};
`;

const ExistingPatient = styled.div.withConfig({ componentId: 'sc-1wvidb8-1' })`
  margin-top: 10px;
  padding: 10px;
  border: 2px solid ${colors.greyHounds};
  border-radius: 4px;
  background-color: ${colors.white};
`;

const getInputProps = (form: any, location: any, initialValues: any) =>
  form.getFieldProps(IS_EXISTING_PATIENT_FIELD_NAME, {
    rules: [
      {
        required: isFieldRequired(IS_EXISTING_PATIENT_FIELD_NAME, location, form.getFieldsValue()),
        validator: emptyFieldValidator,
      },
    ],
    initialValue: initialValues[IS_EXISTING_PATIENT_FIELD_NAME],
  });

type Props = {
  className?: string;
  location: any;
  isExistingPatient: any;
  form: any;
  initialValues: any;
  handleAndTrackLoginFromReturningPatientToggle: (...args: any[]) => any;
  isLoggedIn: boolean;
  accountSummary?: any;
};

const Toggle = ({
  location,
  isExistingPatient,
  form,
  initialValues,
  handleAndTrackLoginFromReturningPatientToggle,
  accountSummary,
  isLoggedIn,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Root>
      <ExistingPatient>
        <ToggleOption
          field={isExistingPatient}
          id={IS_EXISTING_PATIENT_FIELD_NAME}
          inputProps={getInputProps(form, location, initialValues)}
          options={getYesNoToggleOptions(t)}
        />

        <ExistingPatientCta
          // @ts-expect-error ts-migrate(2322) FIXME: Property 'accountSummary' does not exist on type '... Remove this comment to see the full error message
          accountSummary={accountSummary}
          form={form}
          handleAndTrackLoginFromReturningPatientToggle={
            handleAndTrackLoginFromReturningPatientToggle
          }
          isLoggedIn={isLoggedIn}
          location={location}
        />
      </ExistingPatient>
    </Root>
  );
};

export default Toggle;
